import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { DropDownData } from '../CommonComponents/CustomHooks';
import { SetSession } from 'session-manager-beta';

const ManagementSystem = () => {
    const navigate = useNavigate()
    const GetClientData = (code, token) => {
       
        navigate(`/EventSelection?ClientCode=${code}&Token=${token}`);   
        SetSession('localStorage', 'ClientCode', code);
        SetSession('localStorage', 'Token', token);
    }
    let GetClient = DropDownData('GetClientData', '', '', 'APP')

    useEffect(() => {
        document.title = 'Online Download Portal';
    },[])

    return (
        <>
            <section class="front-header-nav-no">
                <div class="mega-front-header">
                    <div class="front-header-main">
                        <div class="mega-front-logo">
                            <img src="./images/logo2.png" />
                        </div>
                        <div class="logo-text">
                            <h1>Online Download Portal</h1>
                        </div>
                    </div>
                </div>
                <div class="mega-front-menu">
                    <div class="front-menu">
                        <ul>
                            <li>
                                <Link class="active">HOME</Link>
                            </li>
                            <li>
                                <Link to='https://www.megacalibre.com/aboutus.aspx' target="_blank">ABOUT US</Link>
                            </li>
                            <li>
                                <Link to='/OnlineManagementSystem'>FAQS</Link>
                            </li>
                        </ul>
                    </div>

                    <div class="container">
                        <div class="row ">
                            <div class="col-lg-10 col-md-10 col-sm-9 col-12" style={{ "marginTop": "4px!important" }} >

                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-3 col-12" style={{ "marginTop": "4px!important" }} >
                                <div class="front-admin-btn mb-4">
                                    {/*<Link to="/" id="btnAdminLogin"><button>Admin Login</button></Link>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="main-body">
                <div class="container">
                    <div class="pg-body-box">
                        <div class="row">
                            <div class="col-lg-4 col-md-3 col-sm-12" style={{ "marginBottom": "-24px !important" }} >
                                <div class="front-select-fileds">
                                    <select
                                        id="ddlInstitution"
                                        name="ddlInstitution"
                                        class="form-select"
                                        tabindex="1"
                                        onChange={(e) => {
                                            const data = JSON.parse(e.target.value);
                                            GetClientData(data.code, data.token);
                                        }}
                                    >
                                        <option value="">Please Select Client</option>
                                        {GetClient?.data?.dataList?.map((item) =>
                                            <option value={JSON.stringify({ code: item.code, token: item.token })}>
                                                {item.name}
                                            </option>
                                        )}

                                    </select>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="front-body-heading">
                                    
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="front-image-select">
                                    <img src="./images/choose-img-1.jpg" class="img-fluid" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="front-image-select">
                                    <img src="./images/choose-img-2.jpg" class="img-fluid" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="front-image-select">
                                    <img src="./images/choose-img-3.jpg" class="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="office-address">
                        <div class="row">
                            <div class="col-12">
                                <div class="text-center office-heading">
                                    <h3>Mega Corporate Offices</h3>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="front-corp-add front-corp-add-first">
                                    <p>Regional Office - East :</p>
                                    <h5>KOLKATA</h5>
                                    <p>06/315 Action Area 1, New Town, Rajarhat, Kolkata-700156 (Behind TATA Medical Centre)</p>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="front-corp-add">
                                    <p>Regd &amp; Head Office :</p>
                                    <h5>NEW DELHI</h5>
                                    <p>D-139, Okhla Industrial Area, Phase-1, New Delhi-110020 &nbsp; <i class="fas fa-phone-alt"></i> +91 11 26816635,37,38</p>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="front-corp-add border-0">
                                    <p>Regional Office - West :</p>
                                    <h5>MUMBAI</h5>
                                    <p>43-44, Mistry Indl Estate, MIDC Cross Road 'A', Near Tunga International, MIDC, Andheri(E), Mumbai-400093 &nbsp; <i class="fas fa-phone-alt"></i> +91 9324568536, +91 22 26878175, 26876626</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="footer-sec-front">
                <div class="front-footer-top">
                    <h2><a href="https://www.megacalibre.com/" target="_blank" style={{ "textDecoration": "none" }} >www.megacalibre.com</a></h2>
                </div>
                <div class="front-choose-footer">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12">
                                <h3>Contact Us</h3>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="choose-ftrl">
                                    <h5>Corporate Affairs</h5>
                                    <p>For corporate affairs please reach out to us at <a href="mailto:info@megacalibre.com" target="_blank">info@megacalibre.com</a></p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="choose-ftrl">
                                    <h5>ITEs Products</h5>
                                    <p>To know more about our products and services please visit us at <a href="https://www.megacalibre.com/" target="_blank">www.megacalibre.com</a></p>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-12">
                                <div class="choose-ftrl choose-ftrl-last">
                                    <h5>Online Download Portal</h5>
                                    <p>To know more about us please mail at <a href="mailto:enquiry@megacalibre.com" target="_blank">enquiry@megacalibre.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default ManagementSystem;